<template>
  <main class="content">
    <loading :isLoading="loaded" />
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-9 d-none d-sm-block">
          <h3><b-icon icon="list" aria-hidden="true"></b-icon> Danh sách đơn hàng</h3>
        </div>
      </div>
      <hr />
      <div class="col-12 col-xl-12">
        <b-container fluid class="my-1">
          <b-row>
            <b-col class="my-1">
              <b-form-group
                label="Filter"
                label-for="filter-input"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Xoá</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col class="my-1">
              <b-form-group
                label="Per page"
                label-for="per-page-select"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                  size="sm"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            :items="orders"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            show-empty
            @filtered="onFiltered"
            :striped="true"
            :bordered="true"
            :borderless="true"
            :outlined="true"
            :hover="true"
            :fixed="true"
            :busy="isBusy"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(price)="row">
              {{ parseInt(row.value) | vnd() }}
            </template>

            <template #cell(actions)="row">
              <b-button size="sm" class="mb-2" @click="onEdit(row.item.id)">
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="mb-2"
                @click="onDelete(row.item)"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </b-button>
            </template>
          </b-table>
          <b-col sm="4" md="4" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
            ></b-pagination>
          </b-col>
        </b-container>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      isBusy: true,
      fields: [
        {
          key: "order.customer_name",
          label: "Tên khách hàng"
        },
        {
          key: "order.customer_phone",
          label: "Số điện thoại"
        },
        {
          key: "price",
          label: "Giá trị đơn hàng"
        },
        { key: "actions", label: "Hành động" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20],
      filter: null,
      filterOn: [],
      loaded: false
    }
  },
  filters: {
    vnd: function (value) {
      return value.toLocaleString('it-IT', {style : 'currency', currency : 'VND'})
    }
  },
  computed: {
    ...mapState({
      orders: (state) => state.order.orders
    })
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("order/get")
      this.totalRows = this.orders.length
      this.isBusy = false
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async onDelete(order) {
      await this.$bvModal
        .msgBoxConfirm("Bạn có muốn xoá đơn hàng này?", {
          title: "Vui lòng xác nhận",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Xoá",
          cancelTitle: "Huỷ bỏ",
          hideBackdrop: true,
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then((value) => {
          if (value) this.deleteOrder(order.id)
        })
        .catch(() => {
          // An error occurred
        })
    },
    async deleteOrder(id) {
      this.loaded = true
      await this.$store.dispatch("order/delete", id)
      this.loaded = false
    },
    onEdit(id) {
      this.$router.push("/order/edit/" + id)
    }
  }
}
</script>